import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import XlsxPopulate from "xlsx-populate";
import { saveAs } from "file-saver";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Form,
  Row,
  Col,
  Input,
} from "reactstrap";

// helpers
import { formateDateandTime, formateDate } from "helpers/formats";

// services
import { api_POST } from "../../../services/api_service.js";
import { api_GET } from "../../../services/api_service.js";
import { showMessage } from "../../../services/message.js";

//Context
import { useAuth } from "../../../context/auth.js";

const fmt = (date) =>
  date ? new Date(date).toLocaleDateString("pt-BR") : "-";

export default function RelatorioRequerimentos({ handleReturn }) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setValue, clearErrors } = useForm({
    mode: "onBlur",
    defaultValues: { statusRequerimento: "TODOS", categoria: "TODOS" },
  });

  const [relatorio, set_relatorio] = useState(null);

  const [categoria, setCategoria] = useState("TODOS");
  const [statusRequerimento, setStatusRequerimento] = useState("TODOS");
  const [subprefeitura, set_Subprefeitura] = useState([]);
  const [options_subprefeitura, set_OptionsSubPrefeitura] = useState([]);

  const componentRef = React.useRef();

  const [optionsCategorias] = useState([
    { value: "TODOS", label: "TODOS" },
    { value: "RCC", label: "RCC" },
    { value: "RGG", label: "RGG" },
    { value: "RSS", label: "RSS" },
  ]);

  const [options_statusRequerimento] = useState([
    { value: "TODOS", label: "TODOS" },
    { value: "Finalizado", label: "Finalizado" },
    { value: "Divergente", label: "Rejeitado" },
    { value: "Em Andamento", label: "Em Andamento" },
    { value: "Pendente", label: "Pendente" },
  ]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
  });

  const handleCategoria = (value) => {
    setCategoria(value);
    setValue("categoria", value, true);
    clearErrors("categoria");
  };

  const handleStatusRequerimento = (value) => {
    setStatusRequerimento(value);
    setValue("statusRequerimento", value, true);
    clearErrors("statusRequerimento");
  };

  const handleSubprefeitura = (value) => {
    set_Subprefeitura(value);
    setValue("subprefeitura", value, true);
  };

  const handleTakeSubprefeituras = () => {
    set_Subprefeitura(options_subprefeitura);
    setValue("subprefeitura", options_subprefeitura, true);
  };

  const buildFiltro = (data) => ({
    categoria: data.categoria || "TODOS",
    statusRequerimento: data.statusRequerimento || "TODOS",
    subPrefeitura:
      subprefeitura && subprefeitura.length > 0
        ? subprefeitura.map((x) => x.subPrefeitura_Id)
        : null,
    dataInicial: data.dataInicial || null,
    dataFinal: data.dataFinal || null,
  });

  const fetchRelatorio = async (filtro) => {
    try {
      setLoading(true);
      const { data } = await api_POST("relatorio/RelatorioRequerimentos", filtro);
      return data;
    } catch (err) {
      showMessage("Aviso", err.message, "error", null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    if (!subprefeitura || subprefeitura.length === 0) {
      showMessage("Aviso", "Selecione ao menos um Regional / SubPrefeitura para gerar o relatório.", "warning", null);
      return;
    }
    const resultado = await fetchRelatorio(buildFiltro(data));
    if (resultado) {
      set_relatorio(resultado);
    } else {
      set_relatorio(null);
    }
  };

  const handleExcel = async () => {
    if (!subprefeitura || subprefeitura.length === 0) {
      showMessage("Aviso", "Selecione ao menos um Regional / SubPrefeitura para gerar o relatório.", "warning", null);
      return;
    }
    const resultado = await fetchRelatorio(
      buildFiltro({
        categoria,
        statusRequerimento,
        dataInicial: document.querySelector("[name=dataInicial]")?.value,
        dataFinal: document.querySelector("[name=dataFinal]")?.value,
      })
    );
    if (!resultado) return;

    const lista = resultado.requerimentos || [];
    const fmt = (date) => date ? new Date(date).toLocaleDateString("pt-BR") : "-";

    const header = [
      "N\u00ba Requerimento", "Status Requerimento", "Categoria", "Tipo de Cadastro", "Tipo de Requerimento",
      "Data de Aprova\u00e7\u00e3o", "Data da \u00daltima Reprova\u00e7\u00e3o", "Total de Reprova\u00e7\u00f5es",
      "Data da \u00daltima Modifica\u00e7\u00e3o", "Emiss\u00e3o da \u00daltima Guia",
      "Raz\u00e3o Social", "Nome Fantasia", "CNPJ/CPF", "Tipo de Pessoa",
      "Endere\u00e7o", "C\u00f3digo de Cadastro", "Respons\u00e1vel Legal", "Ramo de Atividade",
      "Telefone", "E-mail", "Modalidade", "Transportador", "SubPrefeitura",
      "Respons\u00e1vel pela \u00faltima a\u00e7\u00e3o",
    ];

    const fmtDateTime = (date) =>
      date
        ? new Date(date).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" })
        : "-";

    const rows = lista.map((m) => [
      m.numeroRequerimento, m.statusRequerimento, m.categoria, m.tipoCadastro, m.tipoRequerimento,
      fmt(m.dataAprovacao), fmt(m.dataUltimaReprovacao), m.totalReprovacoes,
      fmt(m.dataUltimaModificacao), fmt(m.dataEmissaoUltimaGuia),
      m.razaoSocial, m.nomeFantasia, m.cpf_Cnpj, m.tipoPessoa,
      m.endereco, m.codigoCadastro, m.responsavelLegal, m.ramoAtividade,
      m.telefone, m.email, m.modalidade, m.transportador, m.subprefeitura,
      m.responsavelAnalise || "-",
    ]);

    XlsxPopulate.fromBlankAsync().then((workbook) => {
      const dia = new Date();
      const sheet = workbook.sheet(0).name("Requerimentos");
      sheet.cell("A1").value([header, ...rows]);
      sheet.row(1).style("bold", true);
      return workbook.outputAsync().then((res) => {
        saveAs(res, `RelatorioRequerimentos_${dia.getDate()}${dia.getMonth() + 1}${dia.getFullYear()}.xlsx`);
      });
    });
  };

  useEffect(() => {
    api_GET("subprefeitura")
      .then((result) => set_OptionsSubPrefeitura(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="content">
        <Row>
          <Col md="6" className="noPrint">
            <Button color="Primary" onClick={handleReturn}>
              <i className="fas fa-chevron-left"></i> Voltar
            </Button>
          </Col>
          {relatorio != null && (
            <Col md="6" className="text-right noPrint">
              <Button color="danger" onClick={handlePrint}>
                <i className="fas fa-print"></i>
              </Button>
            </Col>
          )}
        </Row>

        {/* Formulário de filtro */}
        {relatorio == null && (
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="9">
                      <h4 className="mb-0 mt-0">Relatório Requerimentos</h4>
                      <label className="rel-subtitle">
                        Relatório Detalhado de Requerimentos.
                      </label>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="noPrint">
                      {/* Status */}
                      <Col lg="6" md="12">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Status Requerimento:
                          </label>
                          <Select
                            options={options_statusRequerimento}
                            name="statusRequerimento"
                            onChange={(e) => handleStatusRequerimento(e.value)}
                            value={options_statusRequerimento.find(
                              (o) => o.value === statusRequerimento
                            )}
                            placeholder="Selecione"
                            ref={(e) =>
                              register(
                                { name: "statusRequerimento" },
                                { required: true }
                              )
                            }
                          />
                        </FormGroup>
                      </Col>

                      {/* Categoria */}
                      <Col lg="6" md="12">
                        <FormGroup>
                          <label className="form-control-label mt-1">
                            Categoria:
                          </label>
                          <Select
                            options={optionsCategorias}
                            name="categoria"
                            onChange={(e) => handleCategoria(e.value)}
                            value={
                              categoria !== "" &&
                              optionsCategorias.find((o) => o.value === categoria)
                            }
                            placeholder="Selecione"
                            ref={(e) =>
                              register({ name: "categoria" }, { required: true })
                            }
                          />
                        </FormGroup>
                      </Col>

                      {/* Datas — obrigatórias apenas para status Finalizado */}
                      {statusRequerimento === "Finalizado" && (
                        <>
                          <Col lg="6" md="6" sm="12">
                            <FormGroup>
                              <label className="form-control-label">Data Inicial:</label>
                              <Input
                                className="form-control"
                                autoComplete="off"
                                type="date"
                                name="dataInicial"
                                innerRef={register({ required: statusRequerimento === "Finalizado" })}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6" md="6" sm="12">
                            <FormGroup>
                              <label className="form-control-label">Data Final:</label>
                              <Input
                                className="form-control"
                                autoComplete="off"
                                type="date"
                                name="dataFinal"
                                innerRef={register({ required: statusRequerimento === "Finalizado" })}
                              />
                            </FormGroup>
                          </Col>
                        </>
                      )}

                      {/* Subprefeitura */}
                      <Col className="col-12">
                        <FormGroup>
                          <label className="form-control-label">
                            Regional / SubPrefeitura:
                          </label>
                          <Select
                            options={options_subprefeitura}
                            getOptionLabel={(o) => o.nome}
                            getOptionValue={(o) => o.subPrefeitura_Id}
                            name="subprefeitura"
                            onChange={(e) => handleSubprefeitura(e)}
                            value={subprefeitura}
                            placeholder="Selecione"
                            isMulti
                            ref={(e) =>
                              register({ name: "subprefeitura" }, { required: false })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <Button
                          color="sucess"
                          type="button"
                          className="btn btn-link"
                          onClick={handleTakeSubprefeituras}
                        >
                          Selecionar Todos
                        </Button>
                      </Col>

                      <Col lg="2" md="2" sm="12">
                        <Button color="info" className="btn-mobile" type="submit">
                          Gerar Relatório
                        </Button>
                      </Col>
                      <Col lg="2" md="2" sm="12">
                        <Button
                          color="danger"
                          className="btn-mobile"
                          type="button"
                          onClick={handleExcel}
                        >
                          Gerar Excel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* Impressão */}
        {relatorio && (
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <ComponentToPrint relatorio={relatorio} statusRequerimento={statusRequerimento} ref={componentRef} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

      </div>
    </>
  );
}

/* ─── Componente de Impressão ─── */
export const ComponentToPrint = React.forwardRef((props, ref) => {
  const relatorio = props.relatorio;

  return (
    <div ref={ref}>
      <div className="row">
        <div className="col-9">
          <h4 className="mb-0 mt-0">Relatório Detalhado de Requerimentos</h4>
        </div>
        <div className="col-3 text-right">
          <label>Gerado em {formateDateandTime(new Date())}</label>
        </div>
      </div>

      {relatorio != null && (
        <>

          {props.statusRequerimento === "TODOS" && (
            <div className="row mt-2 mb-2">
              <div className="col-12">
                <span style={{ marginRight: 32 }}><b>Finalizados:</b> {relatorio.totalFinalizados}</span>
                <span style={{ marginRight: 32 }}><b>Divergentes:</b> {relatorio.totalDivergentes}</span>
                <span style={{ marginRight: 32 }}><b>Em Andamento:</b> {relatorio.totalEmAndamento}</span>
                <span style={{ marginRight: 32 }}><b>Pendentes:</b> {relatorio.totalPendentes}</span>
                <span><b>Total Geral:</b> {relatorio.total}</span>
              </div>
            </div>
          )}

          {(relatorio.requerimentos || []).map((m, key) => (
            <div className="rel-group" key={key}>
              <div className="row rel-item">

                {/* Identificação */}
                <div className="col-6">
                  <span><b>Nº Requerimento: </b></span>
                  <span>{m.numeroRequerimento || "-"}</span>
                </div>
                <div className="col-6">
                  <span><b>Código de Cadastro: </b></span>
                  <span>{m.codigoCadastro || "-"}</span>
                </div>
                <div className="col-6">
                  <span><b>Status Requerimento: </b></span>
                  <span>{m.statusRequerimento || "-"}</span>
                </div>

                {/* Categoria e tipo */}
                <div className="col-4">
                  <span><b>Categoria: </b></span>
                  <span>{m.categoria || "-"}</span>
                </div>
                <div className="col-4">
                  <span><b>Tipo de Cadastro: </b></span>
                  <span>{m.tipoCadastro || "-"}</span>
                </div>
                <div className="col-4">
                  <span><b>Tipo de Requerimento: </b></span>
                  <span>{m.tipoRequerimento || "-"}</span>
                </div>

                {/* Datas conforme status */}
                {m.dataAprovacao && (
                  <div className="col-6">
                    <span><b>Data de Aprovação: </b></span>
                    <span>{fmt(m.dataAprovacao)}</span>
                  </div>
                )}
                {m.dataUltimaReprovacao && (
                  <>
                    <div className="col-6">
                      <span><b>Data da Última Reprovação: </b></span>
                      <span>{fmt(m.dataUltimaReprovacao)}</span>
                    </div>
                    <div className="col-6">
                      <span><b>Total de Reprovações: </b></span>
                      <span>{m.totalReprovacoes}</span>
                    </div>
                  </>
                )}
                {m.dataUltimaModificacao && !m.dataAprovacao && !m.dataUltimaReprovacao && (
                  <div className="col-6">
                    <span><b>Última Modificação: </b></span>
                    <span>{fmt(m.dataUltimaModificacao)}</span>
                  </div>
                )}
                {m.dataEmissaoUltimaGuia && (
                  <div className="col-6">
                    <span><b>Emissão da Última Guia: </b></span>
                    <span>{fmt(m.dataEmissaoUltimaGuia)}</span>
                  </div>
                )}

                {/* Dados cadastrais */}
                <div className="col-6">
                  <span><b>Razão Social: </b></span>
                  <span>{m.razaoSocial || "-"}</span>
                </div>
                <div className="col-6">
                  <span><b>Nome Fantasia: </b></span>
                  <span>{m.nomeFantasia || "-"}</span>
                </div>
                <div className="col-4">
                  <span><b>CNPJ/CPF: </b></span>
                  <span>{m.cpf_Cnpj || "-"}</span>
                </div>
                <div className="col-4">
                  <span><b>Tipo de Pessoa: </b></span>
                  <span>{m.tipoPessoa || "-"}</span>
                </div>
                <div className="col-4">
                  <span><b>Ramo de Atividade: </b></span>
                  <span>{m.ramoAtividade || "-"}</span>
                </div>
                <div className="col-8">
                  <span><b>Endereço: </b></span>
                  <span>{m.endereco || "-"}</span>
                </div>
                <div className="col-4">
                  <span><b>SubPrefeitura: </b></span>
                  <span>{m.subprefeitura || "-"}</span>
                </div>
                <div className="col-6">
                  <span><b>Responsável Legal: </b></span>
                  <span>{m.responsavelLegal || "-"}</span>
                </div>
                <div className="col-3">
                  <span><b>Telefone: </b></span>
                  <span>{m.telefone || "-"}</span>
                </div>
                <div className="col-6">
                  <span><b>E-mail: </b></span>
                  <span>{m.email || "-"}</span>
                </div>

                {/* Campos específicos de RGG */}
                {!!m.modalidade && (
                  <div className="col-6">
                    <span><b>Modalidade: </b></span>
                    <span>{m.modalidade}</span>
                  </div>
                )}
                {!!m.transportador && (
                  <div className="col-6">
                    <span><b>Transportador: </b></span>
                    <span>{m.transportador}</span>
                  </div>
                )}

                {/* Responsável SP Regula */}
                {!!m.responsavelAnalise && (
                  <div className="col-8">
                    <span><b>Responsável pela última ação: </b></span>
                    <span>{m.responsavelAnalise}</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
});
